import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Col from '../../components/Col';
import Form, { Heading } from '../../components/Form';
import Row from '../../components/Row';
import { PATHS } from 'src/common/constants';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

class ViewImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: '',
      new_password: '',
      confirm_password: '',
    };
  }
  componentDidMount() {}

  validatePasswordForm() {
    const { old_password, new_password, confirm_password } = this.state;

    if (new_password === confirm_password) {
      let data = {
        Username: this.props.user.email,
        Password: old_password,
      };
      let newData = {
        UserId: this.props.user.id,
        Password: new_password,
        NewPassword: confirm_password,
      };
      let history = this.props.history;
      this.props.signIn(data, history, newData);
    } else {
      alert('New Password and confirm password must be same !');
    }
  }
  navigteToMessages() {
    this.props.history.push(
      PATHS.SERVICE_REQUESTS_VIEW.replace(
        ':id',
        this.props.location.state.serviceRequestId
      )
    );
  }
  render() {
    const { image, fileName } = this.props.location.state;
    const thumb = {
      display: 'inline-flex',
      borderRadius: 2,
      border: '1px solid #eaeaea',
      marginBottom: 8,
      marginRight: 8,
      width: 500,
      height: 300,
      padding: 4,
      boxSizing: 'border-box',
    };
    const thumbInner = {
      display: 'flex',
      minWidth: 0,
      overflow: 'hidden',
    };
    const img = {
      display: 'block',
      width: 500,
      height: 300,
    };
    return (
      <Form
        headline={fileName}
        onClose={() => this.navigteToMessages()}
        onSubmit={() => this.validatePasswordForm()}
        actions={<></>}
        component={
          <>
            <Row mdCenter>
              <Col xs="12" md="6">
                <Heading></Heading>
                <>
                  <div style={thumb} key={fileName}>
                    <div style={thumbInner}>
                      <img src={image} style={img} alt={fileName} />
                    </div>
                  </div>
                </>
              </Col>
            </Row>
          </>
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  user: selectAuthenticatedUser(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewImage);
